import { useEffect, useState } from 'react';
import { MdNotificationImportant } from 'react-icons/md';

import { ScheduleStyled } from './styled';

import clsx from 'clsx';
import { get, ref } from 'firebase/database';
import moment from 'moment';
import database from 'src/libraries/firebase';
import { kindToName } from 'src/libraries/health';

interface ScheduleProps {
  className?: string;
}

const weekDay = ['일', '월', '화', '수', '목', '금', '토'];

const Schedule = ({ className }: ScheduleProps) => {
  const [scheduleMoments, setScheduleMoments] = useState(
    Array(7)
      .fill(0)
      .map((_, i) => moment().subtract(6 - i, 'days')),
  );
  const [historys, setHistorys] = useState([]);

  useEffect(() => {
    (async () => {
      const robotSettingRef = ref(database, 'health_robot/history');
      const snapshot = await get(robotSettingRef);
      const robotHealthHistorys = snapshot.val();
      setHistorys(Object.values(robotHealthHistorys));
    })();
  }, []);
  return (
    <ScheduleStyled className={clsx('Schedule', className)}>
      <div className="content">
        <div className="content-header">
          <h3 className="content-title">6월</h3>
          <span>자세히 보기 +</span>
        </div>
        <div className="calendar-content">
          {scheduleMoments.map((scheduleMoment, index) => (
            <div className="day-item">
              <div className="week">{weekDay[scheduleMoment.day()]}</div>
              <div
                className={clsx(
                  'day',
                  index > 0 && 'has',
                  index === 6 && 'active',
                )}
              >
                {scheduleMoment.date()}
              </div>
            </div>
          ))}
        </div>
        <div>6일 연속으로 운동하고 있어요! 🎉</div>
      </div>
      <div className="content history-content">
        {historys.map((history: any, index) => (
          <div className="history-item">
            <div className="title">랫 풀 다운(Lat pull down)</div>
            <div className="bottom">
              <div className="sets">10 x 3 세트</div>
            </div>
          </div>
        ))}
        {historys.length < 1 && (
          <div className="empty">
            <div className="icon">
              <MdNotificationImportant />
            </div>
            운동 기록이 없습니다!
          </div>
        )}
      </div>
    </ScheduleStyled>
  );
};

export default Schedule;
